import React from 'react';
import { Badge } from '../../../components/ui/badge';
import { CalendarDays } from 'lucide-react';
import { MONTHS_RO } from './constants';

export const CalendarView = ({ data, year }) => {
  if (!data) return <div className="flex-1 flex items-center justify-center text-slate-400">Se incarca...</div>;
  const months = {};
  data.days.forEach(d => {
    const parts = d.date.split('.');
    if (parts.length === 3) {
      const m = parseInt(parts[1]);
      if (!months[m]) months[m] = [];
      months[m].push(d);
    }
  });

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4" data-testid="calendar-view">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-slate-900">Calendar validari - {year}</h2>
        <Badge className="bg-blue-100 text-blue-700">{data.days.length} zile cu validari</Badge>
      </div>

      {data.days.length === 0 ? (
        <div className="border-2 border-dashed rounded-xl p-10 text-center">
          <CalendarDays className="w-10 h-10 mx-auto mb-2 text-slate-200" />
          <p className="text-sm text-slate-500">Nicio validare inregistrata in {year}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {Array.from({ length: 12 }, (_, i) => i + 1).map(m => {
            const monthDays = months[m] || [];
            return (
              <div key={m} className={`border rounded-xl overflow-hidden ${monthDays.length > 0 ? '' : 'opacity-50'}`}>
                <div className={`px-3 py-2 text-xs font-semibold ${monthDays.length > 0 ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-400'}`}>
                  {MONTHS_RO[m - 1]} <span className="opacity-70">({monthDays.length} zile)</span>
                </div>
                {monthDays.length > 0 && (
                  <div className="p-2 space-y-1 max-h-40 overflow-y-auto">
                    {monthDays.map((d, di) => (
                      <div key={di} className="bg-emerald-50 rounded px-2 py-1.5">
                        <div className="flex items-center justify-between">
                          <span className="text-xs font-mono font-semibold text-emerald-700">{d.date}</span>
                          <Badge className="bg-emerald-100 text-emerald-700 text-[10px]">{d.count}</Badge>
                        </div>
                        <div className="text-[10px] text-slate-500 mt-0.5">
                          {d.items.slice(0, 2).map((it, ii) => (
                            <span key={ii}>{it.equipment} ({it.type}){ii < 1 && d.items.length > 1 ? ', ' : ''}</span>
                          ))}
                          {d.items.length > 2 && <span> +{d.items.length - 2}</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
